import { get } from '.';

export async function getInvestorbuzzArticle() {
	const article: any = (await get(`/investorbuzz/article/latest`)).data;

	return article;
}
